import { Col } from 'reactstrap';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DashboardCard = ({ stat, statName, filterName, statIcon, statColor }) => {
    const dispatch = useDispatch();
    const onClick = (filterName) => {
        dispatch(actions.practice.setActiveTabPractices(filterName));
    };
    return (
        <Col
            lg="4"
            xs="6"
            className="text-light sc-rounded py-2 pop-hover-sm"
            onClick={() => onClick(filterName)}>
            <div className={classNames('sc-rounded shadow', statColor)}>
                <Col lg="12" md="12" sm="12" className="p-2 d-flex">
                    <Col lg="6" md="6" sm="6" className="text-right">
                        <h1 className="d-none d-md-block">{stat}</h1>
                        <h3 className="d-md-none">{stat}</h3>
                    </Col>
                    <Col lg="6" md="6" sm="6">
                        <FontAwesomeIcon
                            className="text-dark op-5 d-none d-md-block"
                            size="3x"
                            icon={statIcon}
                        />
                        <FontAwesomeIcon
                            className="text-dark op-5 d-md-none"
                            size="2x"
                            icon={statIcon}
                        />
                    </Col>
                </Col>
                <div className="w-100 bg-dark-opacity-3 sc-rounded text-center py-2">
                    {statName}
                </div>
            </div>
        </Col>
    );
};

export default DashboardCard;
